RivalIQ.apps.Site.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Signup = Backbone.Model.extend({
        url: function () {
            const server = _.get(window.RivalIQEnv, ['urlBasepath']);

            return (server ? `${server}/signup` : '/signup');
        },

        validate: function (attrs) {
            const errors = [];

            if (!attrs.email || !attrs.email.match(/.+@.+/)) {
                errors.push(['email', `That email isn't valid.`]);
            }

            if (!attrs.firstName) {
                errors.push(['firstName', 'Please add your first name.']);
            }

            if (!attrs.lastName) {
                errors.push(['lastName', 'Please add your last name.']);
            }

            if (!attrs.leadData.companyName) {
                errors.push(['companyName', 'Please add your company name.']);
            }

            if (!attrs.leadData.companyTitle) {
                errors.push(['companyTitle', 'Please add your title.']);
            }

            if (window.rivalIqSettings.showPhoneNumberField) {
                const phoneNum = attrs.leadData.phoneNumber;
                // Validate that the user provided at least 7 digits
                if (!phoneNum || phoneNum.replace(/[^\d]/g, '').length < 7) {
                    errors.push(['phoneNumber', 'Phone number is not valid.']);
                }
            }

            if (!attrs.companyType) {
                errors.push(['companyType', 'Please tell us if you work for an agency or a brand.']);
            }

            if (!attrs.termsAndConditions) {
                errors.push(['termsAndConditions', 'Please accept the Terms of Use.']);
            }

            if (!errors.length) {
                return null;
            }

            return errors;
        }
    });
});
